import { render } from "./StageSection.vue?vue&type=template&id=03d7e4dc&scoped=true"
import script from "./StageSection.vue?vue&type=script&lang=js"
export * from "./StageSection.vue?vue&type=script&lang=js"

import "./StageSection.vue?vue&type=style&index=0&id=03d7e4dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03d7e4dc"]])

export default __exports__